import React from 'react';

/** PowerPoint illustration — two stacked 16:9 slides, front slide in focus. */
const StackedSlides = () => (
  <div className="ill-slides" aria-hidden="true">
    <div className="ill-slide ill-slide-back">
      <span className="ill-slide-bar ill-slide-bar-title"></span>
      <span className="ill-slide-bar"></span>
      <span className="ill-slide-bar ill-slide-bar-short"></span>
    </div>
    <div className="ill-slide ill-slide-front">
      <span className="ill-slide-bar ill-slide-bar-title"></span>
      <div className="ill-slide-row">
        <span className="ill-slide-block"></span>
        <span className="ill-slide-block"></span>
      </div>
      <span className="ill-slide-bar ill-slide-bar-short"></span>
    </div>
  </div>
);

export default StackedSlides;
